import { useTranslation } from 'react-i18next';

import type { CalculationData, Line } from '~/api/common/types';

import { useIntl } from '~/hooks/useIntl';
import { clsx } from '~/styles/utils';

import { calculateLineDiscount, determineLineVatPercentage } from '../lines.utils';
import { mobileRowStyle, mobileStyle, mobileTotalStyle } from './documentLine.css';
import { DocumentLineDescriptionCell } from './DocumentLineDescriptionCell';

type Props = {
  calculationData: CalculationData;
  line: Line;
};

export const DocumentLineMobileCell = ({ calculationData, line }: Props) => {
  const { formatCurrency, formatDecimal } = useIntl();
  const { t } = useTranslation(['lines']);

  return (
    <div className={mobileStyle}>
      <DocumentLineDescriptionCell line={line} />

      {line.type === 'entry' && (
        <>
          <div className={mobileRowStyle}>
            <span>
              {formatDecimal(line.quantity)} × {formatCurrency(line.price)}
            </span>

            <span>{t('lines:vatPercentage', { percentage: determineLineVatPercentage(line, calculationData) * 100 })}</span>
          </div>

          <div className={clsx(mobileRowStyle, mobileTotalStyle)}>
            <span>{t('lines:lineTotal.header')}</span>

            <span>{formatCurrency(line.quantity * line.price - calculateLineDiscount(line))}</span>
          </div>
        </>
      )}
    </div>
  );
};
